module.exports = __webpack_public_path__ + "img/new-banner.775693c5.jpg";